export function minDate(...values: Date[]): Date {
  return new Date(Math.min(...values.map((value) => Number(value))));
}

export function maxDate(...values: Date[]): Date {
  return new Date(Math.max(...values.map((value) => Number(value))));
}
